import useTranslation from 'next-translate/useTranslation';
import { Dispatch, ReactNode, SetStateAction } from 'react';
import { Control } from 'react-hook-form';
import { SchemaOf, object, string } from 'yup';

import { Translate } from '@core/constant';
import { EButtonVariant, ETypographyVariant } from '@core/type';

import { Button } from '../../button';
import { Box } from '../../layout';
import { Modal } from '../../modal';
import { Typography } from '../../typography';
import { InputPassword } from '../input';

export const validator: SchemaOf<{ password: string }> = object().shape({
  password: string().required(),
});

export const ButtonSaveChanges = ({
  isOpen,
  setIsOpen,
  control,
  children,
  variant = EButtonVariant.CONTAINED,
  form,
  onClick,
}: {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any, any>;
  children: ReactNode;
  variant?: EButtonVariant;
  onClick?: () => void;
  form: string;
}) => {
  const { t } = useTranslation(Translate.common.BUTTON);

  return (
    <>
      <Button
        type="button"
        onClick={() => {
          onClick ? onClick() : setIsOpen(true);
        }}
        variant={variant}
      >
        {children}
      </Button>
      <Modal isOpen={isOpen} onCloseModal={() => setIsOpen(false)}>
        <Modal.Header>
          <Box display="flex" justifyContent="center">
            <Typography variant={ETypographyVariant.H4}>{t('saveChanges.title')}</Typography>
          </Box>
        </Modal.Header>
        <Modal.Body>
          <Box display="flex" flexDirection="column" gap="16px" alignItems="center">
            <Typography variant={ETypographyVariant.BODY2}>{t('saveChanges.confirm')}</Typography>
            <InputPassword control={control} name="password" required></InputPassword>

            <Box display="flex" gap="24px" marginTop={'16px'}>
              <Button variant={EButtonVariant.OUTLINED} onClick={() => setIsOpen(false)}>
                {t('cancel.title')}
              </Button>
              <Button form={form}>{t('saveChanges.title')}</Button>
            </Box>
          </Box>
        </Modal.Body>
      </Modal>
    </>
  );
};
